import { HELP_CENTER as p, SEARCH_RESULT_SECTION_EVENT_NAME as E } from "./help-center-articles-search22.js";
import { getIndexName as R } from "./help-center-articles-search21.js";
import { MAX_NUMBER_OF_RESULTS as r } from "./help-center-articles-search19.js";
import { extractSuggestedQueries as N } from "./help-center-articles-search9.js";
function I(u) {
  const { query: i, location: c, suggestedQueriesResponse: s, env: l, locale: a } = u, t = N(s), m = t.filter((e) => (e._rankingInfo?.nbTypos ?? 0) > 0), o = s.results[0], n = R(a, l), S = r < (o.nbHits ?? 0) ? r : o.nbHits ?? 0, g = {
    query: i,
    location: c,
    sectionName: p,
    resultsInSection: t.map((e) => ({ resultSource: n, id: e.objectID })),
    resultsWithTyposCount: m.length,
    totalResultCount: t.length,
    shownResultsInSection: t.slice(0, S).map((e) => ({ resultSource: n, id: e.objectID }))
  };
  return {
    eventName: E,
    data: g
  };
}
export {
  I as getSearchResultSectionTrackingData
};
//# sourceMappingURL=help-center-articles-search25.js.map
